export default {"src":"/_next/static/media/vector.50a208ba.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};